<template>
	<v-card class="ma-5 d-flex flex-column invitation-code-card" flat>
		<v-card-text class="flex-grow-1 pa-0 d-flex flex-column">
			<v-list v-if="invitationCodes.length" class="invitation-list pa-0 flex-grow-1 d-flex flex-column">
				<v-virtual-scroll :items="invitationCodes" :item-height="48" :height="scrollHeight" class="flex-grow-1">
					<template #default="{ item }">
						<v-list-item class="selectable-text" color="primary" :input-value="selected === item" @click="selected = item">
							<v-list-item-content>
								<v-list-item-title class="code-text">
									{{ item }}
								</v-list-item-title>
							</v-list-item-content>
							<v-list-item-action>
								<v-btn icon small @click.stop="copyCode(item)">
									<v-icon small>mdi-content-copy</v-icon>
								</v-btn>
							</v-list-item-action>
						</v-list-item>
					</template>
				</v-virtual-scroll>
			</v-list>
			<div v-else class="empty-state pa-8 text-center">
				<v-icon size="48" color="grey lighten-1">mdi-ticket-outline</v-icon>
				<p class="mt-4 grey--text">
					{{ $t('no-invitation-codes') || 'No invitation codes' }}
				</p>
			</div>
		</v-card-text>

		<v-divider />

		<v-card-actions class="pa-3">
			<v-spacer />

			<v-btn :disabled="!selected || !invitationCodes.includes(selected)" color="error" text @click="deleteOne">
				<v-icon left small>mdi-delete</v-icon>
				{{ $t("delete") }}
			</v-btn>
			<v-btn color="primary" @click="create">
				<v-icon left small>mdi-plus</v-icon>
				{{ $t("create") }}
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>

export default {
	name: "InvitationCode",

	data() {
		return {
			invitationCodes: [],
			selected: undefined
		};
	},

	computed: {
		scrollHeight() {
			if (this.$vuetify.breakpoint.xs) {
				// fullscreen dialog: viewport - header(64) - card margin(40) - actions(52) - divider(1)
				return window.innerHeight - 157;
			}
			return 300;
		}
	},

	async mounted () {
		this.invitationCodes = (await this.axios.get("onboarding/invitation")).data;
	},

	methods: {
		async fetchInvitations(options) {
			const silent = options?.silent || false;

			try {
				this.invitationCodes = (await this.axios.get("onboarding/invitation")).data;
				return { success: true };
			} catch (err) {
				console.error("Error fetching invitation codes:", err);
				if (!silent) this.$error(this.$t("error.fetch-invitation-codes") || "Failed to load invitation codes");
				return { success: false };
			}
		},

		async create() {
			this.invitationCodes = (await this.axios.post("/onboarding/invitation")).data;
		},

		async deleteOne() {
			await this.axios.delete(`/onboarding/invitation/${this.selected}`);
			this.selected = undefined;
			this.invitationCodes = (await this.axios.get("onboarding/invitation")).data;
		},

		async copyCode(code) {
			try {
				await navigator.clipboard.writeText(code);
				this.$success(this.$t("copied-to-clipboard"));
			} catch (err) {
				console.error("Failed to copy:", err);
			}
		}
	}
};
</script>
<style scoped>
.invitation-code-card {
	min-height: 380px;
	flex: 1;
}

.invitation-code-card > .v-card__text {
	overflow: hidden;
	min-height: 0;
}

.invitation-list {
	background: transparent;
}

.selectable-text {
	user-select: text;
	cursor: pointer;
	border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.selectable-text:hover {
	background: rgba(0, 0, 0, 0.04);
}

.code-text {
	font-family: monospace;
	font-size: 14px;
	letter-spacing: 1px;
}

.empty-state {
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
</style>
